import React, {useState} from 'react';
import {Box, SwipeableDrawer, useTheme} from '@mui/material';
import {Outlet} from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import {useIsMobile} from "@/hooks/use-mobile.tsx";

const DRAWER_WIDTH = 220;
const COLLAPSED_DRAWER_WIDTH = 65;

const AppLayout = () => {
  const [open, setOpen] = useState(true);
  const theme = useTheme();
  const isMobile = useIsMobile()

  React.useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, [isMobile]);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    if (isMobile) {
      setOpen(false);
    }
  };

  return (
    <Box sx={{
      display: 'grid',
      gridTemplateRows: 'auto 1fr',
      height: '100vh',
      height: '100dvh',
      width: '100%',
      overflow: 'hidden'
    }}>
      <Header toggleDrawer={toggleDrawer} sidebarOpen={open} />

      <Box sx={{
        display: 'flex',
        overflow: 'hidden',
        gridTemplateColumns: {
          sm: `${open ? DRAWER_WIDTH : COLLAPSED_DRAWER_WIDTH}px 1fr`,
          xs: '0px 1fr'
        },
        transition: theme.transitions.create('grid-template-columns', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      }}>
        {/* Desktop Sidebar */}
        {!isMobile && (
          <Box sx={{
            height: '100%',
            display: { xs: 'none', sm: 'block' },
          }}>
            <Sidebar
              open={open}
              onToggle={toggleDrawer}
              drawerWidth={DRAWER_WIDTH}
              collapsedWidth={COLLAPSED_DRAWER_WIDTH}
              variant="permanent"
            />
          </Box>
        )}

        {/* Mobile Sidebar - Slides in on top */}
        <SwipeableDrawer
          open={isMobile && open}
          onOpen={toggleDrawer}
          onClose={handleClose}
          disableBackdropTransition={false}
          disableDiscovery={true}
          ModalProps={{
            keepMounted: true, // Better performance on mobile
          }}
          PaperProps={{
            // Override the Paper component styling
            sx: {
              width: DRAWER_WIDTH,
              boxSizing: 'border-box',
              boxShadow: 3,
              bgcolor: 'background.paper', // Use the same background as desktop
              '--Paper-overlay': 'none', // Remove the overlay styling
              borderRight: '1px solid',
              borderColor: 'divider',
              backgroundImage: 'none', // Remove any background image
              overflowX: 'hidden',
            }
          }}
          sx={{
            display: isMobile ? 'block' : 'none',
            zIndex: theme.zIndex.drawer + 2,
          }}
        >
          <Sidebar
            open={true} // Always open in the mobile drawer
            onToggle={toggleDrawer}
            drawerWidth={DRAWER_WIDTH}
            collapsedWidth={COLLAPSED_DRAWER_WIDTH}
            variant="temporary"
          />
        </SwipeableDrawer>

        <Box sx={{
          flex: 1,
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          '& > *': {
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box'
          }
        }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AppLayout;
